export const LIVECAPTION_INUSE_STATE = { DISABLED: "0", ENABLED: "1" };
export const HOST_NAME = "Host";
